export default __webpack_public_path__ + "static/works-image3-d1784604b8de009b5576e71d39cb343e.jpg";